import {Component, OnInit} from '@angular/core';
import {SiUtil} from '../../../utility/SiUtil';
import {MasterBean} from '../../../utility/MasterBean';
import {Router} from '@angular/router';
import {Injector} from '@angular/core';
import {MasterProvider} from '../../../utility/MasterProvider';
import {MAT_DIALOG_DATA, MatDialogRef, MatDatepickerInputEvent, DateAdapter, MatSnackBar} from '@angular/material';
import {Inject} from '@angular/core';
import {DialogData} from '../../../pojos/DialogData';
import {FormBuilder} from '@angular/forms';
import {FormControl} from '@angular/forms';
import {Validators} from '@angular/forms';
import {LedgerMst} from '../../../pojos/LedgerMst';
import {LazyLoadRequest} from '../../../request/LazyLoadRequest';
import {SigninRequest} from '../edit-profile/signin-request';
import {HttpEventType} from '@angular/common/http';
import {HttpResponse} from '@angular/common/http';
import {debounceTime} from 'rxjs/internal/operators/debounceTime';
import {tap} from 'rxjs/internal/operators/tap';
import {switchMap} from 'rxjs/internal/operators/switchMap';
import {finalize} from 'rxjs/internal/operators/finalize';
import {CustomerDialogComponent} from '../customers/customer-dialog/customer-dialog.component';
import {CustomerDialogRequest} from '../customers/customer-dialog/customer-dialog-request';
//import { Model } from "/ContactComponent-form";
import {NgForm} from '@angular/forms';
import "assets/smtp.js";
import {HttpClient} from '@angular/common/http';
import {DatePipe} from '@angular/common';
import {SelectedProduct} from '../../../pojos/SelectedProduct';
import {Gst} from '../../../pojos/Gst';
import { ElementRef } from '@angular/core';
import {NonTaxableInvoiceCalculationComponent} from '../nonTaxableInvoiceCalculation/nonTaxableInvoiceCalculation.component';


interface FreightTax {
    value: string;
    viewValue: string;
}
@Component({
    selector: 'app-setting_generator',
    templateUrl: './setting_generator.component.html',
    styleUrls: ['./setting_generator.component.scss']
})

export class Setting_GeneratorComponent extends MasterBean implements OnInit {

   

    
  
    constructor(public router: Router, private dateAdapter: DateAdapter<Date>,
        public injector: Injector,public snackBar: MatSnackBar,public elementRef:ElementRef,
        public provider: MasterProvider, public datePipe: DatePipe,
        public formBuilder: FormBuilder,
          public dialog: MatDialogRef<Setting_GeneratorComponent>,
       
        @Inject(MAT_DIALOG_DATA) public pageParam: DialogData,
    ) {
        super(injector, router, provider);
        
        

    }
    async ngOnInit(): Promise<void> {


       if (this.pageParam.formMode == "SAVE") {
////
      
           
            var data = await this.registrationForm(this.FORM_TYPE_MASTER);
            this.formMode(this.pageParam.formMode);
//
    }
      


    }
    invoice(){
      
    }
     close() {
         this.dialog.close();   

    }
 
    public onNewClickedAction(event?: any) {

    }
    public onNewSaveAction(event?: any) {
       
    }
    public onModifyClickedAction(event?: any) {

    }
    public onUpdateSaveAction(event?: any) {
    }
    public onRemoveClickedAction(event?: any) {

    }
    public onDeleteSaveAction(event?: any) {

    }
    public onViewClickedAction(event?: any) {

    }
    public onUploadClickedAction(event?: any) {

    }
    public formSaveMode() {

    }
    public formUpdateMode() {
    }
    public formDeleteMode() {

    }
    public formViewMode() {

    }
    public formListMod() {

    }
    controlOninit() {}
       

}
